export default "__VITE_ASSET__CAyfY6mI__"